import React from 'react';
import HeroImage from '../assets/heroImage1.png';
import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-scroll';
import Typewriter from 'typewriter-effect';

const Home = () => {
  return (
    <div name='home' className='h-screen w-full bg-gradient-to-b from-black via-black to-gray-800'>
      <div className='max-w-screen-lg mx-auto flex flex-col md:flex-row items-center justify-center h-full px-4'>
        <div className='flex flex-col justify-center h-full max-w-md'>
          <div className='mt-14 text-4xl sm:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-200'>
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .typeString('I am a Fullstack Developer')
                  .callFunction(() => {
                    console.log('String typed out!');
                  })
                  .pauseFor(2500)
                  .callFunction(() => {
                    console.log('All strings were deleted');
                  })
                  .start();
              }}
            />
          </div>
          <p className='text-gray-500 py-4'>
            As a beginner Web Developer, I have a passion for creating visually
            appealing and functional digital content. I am constantly seeking
            to improve my skills and expand my knowledge, experimenting with
            different tools and techniques to create engaging designs and
            user-friendly websites. With a combination of creativity and
            technical know-how, I am eager to bring my ideas to life and make a
            meaningful impact in the digital world.
          </p>
          <div>
            <Link
              to='portfolio'
              smooth
              duration={800}
              className='group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-green-400 cursor-pointer'
            >
              Portfolio
              <span className='group-hover:rotate-90 duration-300'>
                <FiArrowRight size={20} className='ml-1' />
              </span>
            </Link>
          </div>
        </div>
        <div className='flex justify-end w-auto'>
          <img src={HeroImage} alt='my profile' className='rounded-2xl w-3/4 h-3/4' />
        </div>
      </div>
    </div>
  );
};

export default Home;
